// extracted by mini-css-extract-plugin
export default {"badge-button-wrapper":"_3JZSQ","badgeButtonWrapper":"_3JZSQ","badge-button":"_1GjYY","badgeButton":"_1GjYY","badge":"_322PP"};